export const astralLength = (string) => string.replace(/./gu, "_").length;

export const countWords = (text) => text ? text.split(" ").length : 0;
